import React from 'react';
import ReactDOM from 'react-dom';
import Landing from '../../views/common/Landing';
import { findDOMNode } from 'react-dom';
import '../../mdl/materialUsage.css';
import '../../home/style.violet.css';
import '../../home/custom.css';

import '../../css/myHome.css';
import $ from 'jquery';
import HmAjax from '../../util/HmAjax';

/*import TopicComponent from '../../views/plp/TopicComponent';*/
/*import SubTopicComponent from '../../views/plp/SubTopicComponent';*/
/*
* Using Extended component
*/
import TopicComponent from './ms_topiccomponent';
import SubTopicComponent from './ms_subtopiccomponent';

import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import SubscribeModal from "../../views/plp/SubscribeModal";

import Loader from 'react-loader-spinner';
import Ms_testinfo from '../mindstretcher/ms_TestInfo';
import GetTest from '../../views/plp/GetTest';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
//import { Table } from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

/*import Swiper from 'react-id-swiper';*/
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import LessonComponent from '../../views/scorecard/LessonComponent';
import recomLessonIcon from '../../images/icons/recom_lesson.png';

import DesktopOnly from '../../views/warning/DesktopOnly';
import TimerComp from './TimerComp';

var topicListPlaceHolder = "{\"4\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":4,\"topicId\":2,\"subTopicId\":4,\"topicName\":\"Decimals\",\"subTopicName\":\"Introduction to Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":4,\"testId\":1,\"revisiontestid\":4,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"4\",\"recommendtestid\":\"2\",\"testScore\":\"1\",\"testTotalScore\":\"10\",\"recommendTestScore\":\"3\",\"recommendTestTotalScore\":\"9\",\"cumulativeScore\":\"4\",\"cumulativeTotalScore\":\"10\"},\"displayorder\":1,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"5\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":5,\"topicId\":2,\"subTopicId\":5,\"topicName\":\"Decimals\",\"subTopicName\":\"Addition and Subtraction of Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":5,\"testId\":9,\"revisiontestid\":5,\"testStatus\":\"IN_PROGRESS\",\"reqTestStatus\":null,\"referenceId\":\"5\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":2,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"6\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":6,\"topicId\":2,\"subTopicId\":6,\"topicName\":\"Decimals\",\"subTopicName\":\"Multiplication and Division of Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":6,\"testId\":39,\"revisiontestid\":6,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"NEW\",\"referenceId\":\"6\",\"recommendtestid\":\"40\",\"testScore\":\"1\",\"testTotalScore\":\"7\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"6\",\"cumulativeScore\":\"1\",\"cumulativeTotalScore\":\"7\"},\"displayorder\":3,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"7\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":7,\"topicId\":2,\"subTopicId\":7,\"topicName\":\"Decimals\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":7,\"testId\":52,\"revisiontestid\":7,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"NEW\",\"referenceId\":\"7\",\"recommendtestid\":\"53\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"5\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":4,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"12\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":12,\"topicId\":5,\"subTopicId\":12,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"Prime Factors and Tests of Divisibility\",\"subtopicStatus\":{\"topicsubtopicId\":12,\"testId\":13,\"revisiontestid\":12,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"12\",\"recommendtestid\":\"14\",\"testScore\":\"0\",\"testTotalScore\":\"3\",\"recommendTestScore\":\"2\",\"recommendTestTotalScore\":\"3\",\"cumulativeScore\":\"2\",\"cumulativeTotalScore\":\"3\"},\"displayorder\":5,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"13\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":13,\"topicId\":5,\"subTopicId\":13,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"HCF and LCM\",\"subtopicStatus\":{\"topicsubtopicId\":13,\"testId\":19,\"revisiontestid\":13,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"13\",\"recommendtestid\":\"20\",\"testScore\":\"0\",\"testTotalScore\":\"4\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"4\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"4\"},\"displayorder\":6,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"14\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":14,\"topicId\":5,\"subTopicId\":7,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":14,\"testId\":22,\"revisiontestid\":14,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"14\",\"recommendtestid\":\"23\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"1\",\"recommendTestTotalScore\":\"5\",\"cumulativeScore\":\"1\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":7,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"15\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":15,\"topicId\":6,\"subTopicId\":14,\"topicName\":\"Fractions\",\"subTopicName\":\"Introduction to Fractions\",\"subtopicStatus\":{\"topicsubtopicId\":15,\"testId\":0,\"revisiontestid\":15,\"testStatus\":null,\"reqTestStatus\":null,\"referenceId\":\"0\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"0\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"0\"},\"displayorder\":8,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"16\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":16,\"topicId\":6,\"subTopicId\":15,\"topicName\":\"Fractions\",\"subTopicName\":\"Addition and Subtraction of fractions\",\"subtopicStatus\":{\"topicsubtopicId\":16,\"testId\":44,\"revisiontestid\":16,\"testStatus\":\"NEW\",\"reqTestStatus\":null,\"referenceId\":\"16\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"7\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"7\"},\"displayorder\":9,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"17\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":17,\"topicId\":6,\"subTopicId\":16,\"topicName\":\"Fractions\",\"subTopicName\":\"Multiplication and Division of fractions\",\"subtopicStatus\":{\"topicsubtopicId\":17,\"testId\":54,\"revisiontestid\":17,\"testStatus\":\"IN_PROGRESS\",\"reqTestStatus\":null,\"referenceId\":\"17\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"6\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"6\"},\"displayorder\":10,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"18\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":18,\"topicId\":6,\"subTopicId\":7,\"topicName\":\"Fractions\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":18,\"testId\":41,\"revisiontestid\":18,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"18\",\"recommendtestid\":\"42\",\"testScore\":\"0\",\"testTotalScore\":\"4\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"4\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"4\"},\"displayorder\":11,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"19\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":19,\"topicId\":7,\"subTopicId\":17,\"topicName\":\"Percentages\",\"subTopicName\":\"Percentages\",\"subtopicStatus\":{\"topicsubtopicId\":19,\"testId\":34,\"revisiontestid\":19,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"19\",\"recommendtestid\":\"51\",\"testScore\":\"0\",\"testTotalScore\":\"8\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"8\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"8\"},\"displayorder\":12,\"styleid\":4,\"animationGif\":\"05-fivepercentage\"},\"20\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":20,\"topicId\":7,\"subTopicId\":18,\"topicName\":\"Percentages\",\"subTopicName\":\"More on Percentages\",\"subtopicStatus\":{\"topicsubtopicId\":20,\"testId\":50,\"revisiontestid\":20,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"20\",\"recommendtestid\":\"56\",\"testScore\":\"2\",\"testTotalScore\":\"8\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"6\",\"cumulativeScore\":\"2\",\"cumulativeTotalScore\":\"8\"},\"displayorder\":13,\"styleid\":4,\"animationGif\":\"05-fivepercentage\"}}"
//var selectedProductOption = "";
//var selectedGradeOption = "";

var settings = {
		  dots: false,
		  infinite: false,
		  speed: 300,
		  slidesToShow: 5,
		  slidesToScroll: 5,
		  responsive: [
			 {
		      breakpoint: 1370,
		      settings: {
		        slidesToShow: 4,
		        slidesToScroll: 4,
		        infinite: false,
		        dots: false
		      }
		    },
		    {
		      breakpoint: 1100,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		        infinite: false,
		        dots: false
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 550,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		    // You can unslick at a given breakpoint now by adding:
		    // settings: "unslick"
		    // instead of a settings object
		  ]
};

function groupTopicsBy(list,lessonOnlyMode){
	var topicList = [];
	var tempTopicMap = {};

	for(var i in list){
		if(list[i].subtopicStatus){

			var topicId = list[i].topicId;

			var topicOb = tempTopicMap[topicId];
			if(topicOb == null){
				topicOb = {};
			//Topic Atttributes here
			topicOb.topicId = topicId;
			topicOb.classId = list[i].classId;
			topicOb.className = list[i].className;
			topicOb.topicName = list[i].topicName;
			topicOb.topicDescription = list[i].topicDescription;
			topicOb.topicSubTopicMapId = list[i].topicSubTopicMapId;
			topicOb.staticImgPath = list[i].staticImgPath;
			topicOb.animatedImgPath = list[i].animatedImgPath;
			topicOb.colourCode = list[i].colourCode;
			topicOb.styleid = list[i].styleid;
			topicOb.statusArr = [];
			topicOb.scoreNumeratorArr = [];
			topicOb.scoreDenominatorArr = [];		
			topicOb.topicPoints = 0;
			topicOb.userTopicPoints = 0;

			//Check if topic is locked
			topicOb.topicLocked = (list[i].topicLocked && list[i].topicLocked === true) ? list[i].topicLocked : false;

			//topicOb.practiceLocked = list[i].practiceLocked;	
		}

		if(topicOb["subTopicMap"] != undefined && topicOb["subTopicMap"] != null){
			topicOb["subTopicMap"];
		}else{
			topicOb["subTopicMap"] = {};
			topicOb["sortedSubTopicArr"] = [];			
		}

		if(!topicOb["subTopicMap"][list[i].subTopicId]){
			var subTopicObj = {};
			//Subtopic Atttributes here

			subTopicObj.subTopicId = list[i].subTopicId;
			subTopicObj.subTopicName = list[i].subTopicName;
			subTopicObj.reqTestStatus = (list[i].subtopicStatus.reqTestStatus) ? list[i].subtopicStatus.reqTestStatus : null;
			subTopicObj.revisiontestid = list[i].subtopicStatus.revisiontestid;
			subTopicObj.testId = list[i].subtopicStatus.testId;
			subTopicObj.testStatus = (list[i].subtopicStatus.testStatus) ? list[i].subtopicStatus.testStatus : null;
			subTopicObj.topicsubtopicId = list[i].subtopicStatus.topicsubtopicId;
			subTopicObj.recommendtestid  = list[i].subtopicStatus.recommendtestid;
			subTopicObj.displayorder = list[i].displayorder;
			topicOb.topicPoints += subTopicObj.subTopicPoints = (list[i].subtopicStatus.subTopicPoints) ? list[i].subtopicStatus.subTopicPoints : 0;
			topicOb.userTopicPoints += subTopicObj.userPoints = (list[i].subtopicStatus.userPoints) ? list[i].subtopicStatus.userPoints : 0;
			subTopicObj.grade = (list[i].subtopicStatus.grade) ? list[i].subtopicStatus.grade : "";

			subTopicObj.cumulativeScore  = parseInt(list[i].subtopicStatus.cumulativeScore);
			subTopicObj.cumulativeTotalScore  = parseInt(list[i].subtopicStatus.cumulativeTotalScore);
			subTopicObj.recommendTestScore  = parseInt(list[i].subtopicStatus.recommendTestScore);
			subTopicObj.recommendTestTotalScore  = parseInt(list[i].subtopicStatus.recommendTestTotalScore);
			subTopicObj.testScore  = parseInt(list[i].subtopicStatus.testScore);
			subTopicObj.testTotalScore  = parseInt(list[i].subtopicStatus.testTotalScore);
			subTopicObj.percentScore = Math.round((subTopicObj.cumulativeScore / subTopicObj.cumulativeTotalScore) * 100);
			subTopicObj.topicNumerator = subTopicObj.cumulativeScore;
			subTopicObj.topicDenominator = subTopicObj.cumulativeTotalScore;
			subTopicObj.rating = parseInt(list[i].subtopicStatus.rating);
			subTopicObj.parentTopicId = topicId;
			subTopicObj.practiceLocked = list[i].practiceLocked;
			subTopicObj.purchased = list[i].purchased;
			
			subTopicObj.noOfRetakesAvailable = parseInt(list[i].subtopicStatus.noOfRetakesAvailable);

			if(lessonOnlyMode){
				subTopicObj.lessonsSubTopicArr = list[i].subtopicStatus.lessonDefnList;
			}

			if(list[i].subtopicStatus  != null){
				if(list[i].subtopicStatus.reqTestStatus == null && list[i].subtopicStatus.testStatus == null){
					subTopicObj.status = "NEW";
				}else if((list[i].subtopicStatus.reqTestStatus == "NEW" && list[i].subtopicStatus.testStatus == null) || (list[i].subtopicStatus.reqTestStatus == null && list[i].subtopicStatus.testStatus == "NEW")){
					subTopicObj.status = "NEW";
				}else if(list[i].subtopicStatus.reqTestStatus == "COMPLETED"  && list[i].subtopicStatus.testStatus == "COMPLETED"){
					subTopicObj.status = "COMPLETED";
				}else if(list[i].subtopicStatus.recommendtestid == 0  && list[i].subtopicStatus.testStatus == "COMPLETED"){
					subTopicObj.status = "COMPLETED";
				}else {
					subTopicObj.status = "IN_PROGRESS";
				}
			}else{
				subTopicObj.status = "NEW";
			}
			
			if(lessonOnlyMode){
				subTopicObj.status = list[i].subtopicStatus.lessonStatus;
			}

			topicOb.scoreNumeratorArr.push(subTopicObj.topicNumerator);
			topicOb.scoreDenominatorArr.push(subTopicObj.topicDenominator);
			topicOb.statusArr.push(subTopicObj.status);			
			topicOb["subTopicMap"][subTopicObj.subTopicId] = subTopicObj;
			topicOb["sortedSubTopicArr"].push(subTopicObj);
			
			
		}

		tempTopicMap[topicId] = topicOb;
	}
	//console.log("Temp topic ",topicOb)
}

for(var j in tempTopicMap){
	topicList.push(topicStatusCheck(tempTopicMap[j]));
}

	//Sorting of Topics goes here
	topicList = sortTopics(topicList);

	//console.log("topicList ::", topicList);
	return topicList;
}
function topicStatusCheck(topicOb) {	
	try {
		if (topicOb.statusArr != null) {
			if (topicOb.statusArr.indexOf("IN_PROGRESS") >= 0) {
				topicOb.status = "IN_PROGRESS";
			} else {
				if (topicOb.statusArr.indexOf("NEW") < 0 && topicOb.statusArr.indexOf("UN_ATTEMPTED") < 0) {
					topicOb.status = "COMPLETED";
				} 
				else {
					if (topicOb.statusArr.indexOf("COMPLETED") < 0) {
						topicOb.status = "NEW";
					} else {
						topicOb.status = "IN_PROGRESS";
					}
				}
			}
		}

		if (topicOb.scoreNumeratorArr != null && topicOb.scoreDenominatorArr != null) {
			var _numerator = 0;
			var _denominator = 0;
			for(var i=0;i<topicOb.scoreNumeratorArr.length;i++){
				_numerator += topicOb.scoreNumeratorArr[i];
				_denominator += topicOb.scoreDenominatorArr[i];
			}
			var percentScore = Math.round((_numerator/_denominator)*100);
			topicOb.percentScore = percentScore;
		}
	} catch (e) {
	}
	return topicOb;
}
/**
 * Topics Sorting is not present. Future Implementation if required
 */
 function sortTopics(topicObj){
 	try{
 		for(var t in topicObj){
 			topicObj[t]["sortedSubTopicArr"] = sortSubTopics(topicObj[t]["sortedSubTopicArr"]);
 		}
 	}catch(e){}

 	return topicObj;
 }
/**
 * Sub-Topics Sorting
 */
 function sortSubTopics(subTopicArr){
 	try{
 		var sortedSubTopicArr = subTopicArr.sort(function(a,b){
 			return a.displayorder - b.displayorder;
 		});

 		return sortedSubTopicArr;
 	}catch(e){}

 	return subTopicArr;
 }
 const loadingView = "loadingView";
 const topicView = "topicView";
 const subTopicView = "subTopicView";
 const messageView = "messageView";
 const productExpiredView = "productExpiredView";
 const allTopicsView = "allTopicsView";
 const pointsSystemView = "pointsSystemView";
const noProductView = "noProductView";
const desktopOnlyView = "desktopOnlyView";
 let gradePointsMap = {"grades":[{"id":1,"name":"defaultGradeCalculator","grade":"C","minPercent":0,"maxPercent":39},{"id":1,"name":"defaultGradeCalculator","grade":"B","minPercent":40,"maxPercent":64},{"id":1,"name":"defaultGradeCalculator","grade":"B+","minPercent":65,"maxPercent":74},{"id":1,"name":"defaultGradeCalculator","grade":"A","minPercent":75,"maxPercent":84},{"id":1,"name":"defaultGradeCalculator","grade":"A+","minPercent":85,"maxPercent":100}],"points":{"hard":{"1":30,"2":20,"3":15},"medium":{"1":20,"2":13,"3":10},"easy":{"1":10,"2":7,"3":5}}};
 
 
 class ms_Home extends Landing{

 	constructor(props) {
 		super(props);

 		this.state = {
 			topics: [],
 			subtopics: [],
 			selectedTopic:[],
 			selectedSubTopic:[],
 			selectedTopicIndex:null,
 			view: loadingView,
 			message:"",
 			modalShow:false,
 			modalContent:"loading",
 			modalTitle:"",
 			modalView:"loading",
 			productArr:[],
 			gradeArr:[],
 			lessonOnlyMode:false,
 			subTopicBoxColor:"#77b900",
 			productExpired:false,
 			noProducts:false,
			topicSubView:allTopicsView,
			purchased:true,
			SubscribeModal:false,
			timerShow:false,
			elapsedTime:0
 		};

		
 		this.onTopicChangedEvent = this.onTopicChangedEvent.bind(this);
 		this.onSubTopicChangedEvent = this.onSubTopicChangedEvent.bind(this);
 		this.getTopicList = this.getTopicList.bind(this);
 		this.showAllTopics = this.showAllTopics.bind(this);
 		this.showModal = this.showModal.bind(this);
 		this.hideModal = this.hideModal.bind(this);
 		this.startTest = this.startTest.bind(this);
 		this.topicPointClick = this.topicPointClick.bind(this);
 		this.setModalBackdropClose = this.setModalBackdropClose.bind(this);

 		
 		this.accessId = 0;
 		this.gradeProductMap = {};

 		this.selectedGradeOption = null;
 		this.selectedProductOption = null;
 		this.comboNamesLoaded = false;
 		this.gradeStore = null;
 		this.homeDropDownKey = "homeDropdown";
 		this.preferredGrade = null;
 		this.preferredProduct = null;
 		this.TestTypeLbl = "";
		 
		 this.showSubscribemodal= this.showSubscribemodal.bind(this);
		 this.hideSubscribeModal= this.hideSubscribeModal.bind(this);
 		
		 this.assignStateFromParent = this.assignStateFromParent.bind(this);
		 this.showFormobile=this.showFormobile.bind(this);

		 this.goToLanding = this.goToLanding.bind(this);

		 this.setChild(this,"HOME");
		 this.closeTimer = this.closeTimer.bind(this);
		 this.starttime = 0;
		 this.topicInfoObj = {};
		 this.getelapsedTime = this.getelapsedTime.bind(this);
		 this.updateelapsedTime = this.updateelapsedTime.bind(this);
		 this.autoSubmit = this.autoSubmit.bind(this);
		 this.startTimer = this.startTimer.bind(this);
		 this.resumeTimer = this.resumeTimer.bind(this);
		 this.pauseTimer = this.pauseTimer.bind(this);
		 this.closeTimer = this.closeTimer.bind(this);
 	}
 	
 	assignStateFromParent(obj){
 		if(obj){
 			this.setState(obj);
 		}
 	}
 	
	componentDidMount(){
		super.componentDidMount();
		
		if(this.productsAvailableToAccess()){			
			//this.getGradeList();
			this.getPointDetails();
		}
		this.fireMobileToast();
	}
	
	productsAvailableToAccess(){
		var user = this.getUser();
		if(user != null){
			var permissions = user.getPermissions();
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	isLessonTabAvailable(){
		//This is restricted to only Mobile check for now
		return this.showFormobile();
	}

	showFormobile(){
		var isMobileOrTab = this.isTab() || this.isMobile();

		var lessonLockForGrades =  window.lessonLockForGrades || [];
		var gradeVal = !isNaN(this.selectedGradeOption.value) ? Number(this.selectedGradeOption.value) : 0;

		return !(lessonLockForGrades.indexOf(gradeVal) > -1 && isMobileOrTab);
	}
	
	getPointDetails(){
		var me = this;
		var callBackSuccess = function(response){		
			//console.log("point response::",response);	
			if(response){
				gradePointsMap = response;
			}
		}

		var callBackFailure = function(response){
			console.log("Failure::: in GET_POINTS_DETAILS");
		}
		
		new HmAjax(this.getUrlFor("GET_POINTS_DETAILS")).get(callBackSuccess,callBackFailure);	
	}
	
	getTopicList(myView=null){
		var me = this;
		
		me.setState({productExpired:false,topicSubView:allTopicsView});
		var permissions = this.getUser().getPermissions();
		var entlhistory = this.getUser().getEntlHistory();
		//console.log(permissions);
		//console.log(entlhistory);
		/*if((permissions && Object.keys(permissions).length <= 0) && (entlhistory && Object.keys(entlhistory).length <= 0)){
			alert("no products for you..");	
			return;
		}else if((permissions && Object.keys(permissions).length <= 0)){
			alert("products expired...");	
			return;
		}*/
					
					
		
		var serviceType = null;
		var accessId = 0;

		if(me.selectedProductOption.value !== undefined && me.selectedProductOption.value !== null && me.selectedProductOption.value.length > 0){
			if(me.selectedProductOption.value.toLowerCase().indexOf("revision") > 0){
				serviceType = "revision";
			}else if(me.selectedProductOption.value.toLowerCase().indexOf("test") > 0){
				serviceType = "test";
			}
		}
		accessId = !isNaN(me.selectedProductOption.value) ? me.selectedProductOption.value : accessId;

		this.accessId = accessId;
		if(this.accessId == 3){
			me.setState({lessonOnlyMode:true});
		}else{
			me.setState({lessonOnlyMode:false});
		}
		
		try{
			if(permissions[accessId]){
				var levels = permissions[accessId].split(",");
				//console.log("me.selectedProductOption.value=="+me.selectedProductOption.value);
				//console.log(products,me.selectedProductOption.value,$.inArray(me.selectedProductOption.value, products));
				if($.inArray(me.selectedGradeOption.value, levels) < 0){
					me.setState({productExpired:true,view:productExpiredView});
					
					try{
						this.gradeStore = {
							"grd":me.selectedGradeOption.value,
							"prod":accessId
						}
						this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));
					}catch(e){}
					
					
					try{
						var trackObj = {
							"grade_id": me.selectedGradeOption.value,
							"product_type": accessId,
							"source":this.getTracker().enums.selectedProductSource.home
						}			
				
						this.initiateTrack("product_selected",trackObj);
					}catch(e){}
		
					return;
				}
			}else{
				me.setState({productExpired:true,view:productExpiredView});
				
				try{
					this.gradeStore = {
						"grd":me.selectedGradeOption.value,
						"prod":accessId
					}
					this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));
				}catch(e){}
				
				
				try{
					var trackObj = {
						"grade_id": me.selectedGradeOption.value,
						"product_type": accessId,
						"source":this.getTracker().enums.selectedProductSource.home
					}			
			
					this.initiateTrack("product_selected",trackObj);
				}catch(e){}
		
				return;
			}
		}catch(e){}
		
		
		if(myView === null){
			myView = topicView;
		}
		this.setState({ modalShow: false, modalContent:"loading", view:loadingView, modalTitle:"", modalView:"loading" });
		var callBackSuccess = function(response){		
			if(response.code === 200){
				var topicListObj = JSON.parse(response.data);
				
				var topicListObjFinal = groupTopicsBy(topicListObj,me.state.lessonOnlyMode);

				if(topicListObjFinal && topicListObjFinal.length > 0){
					
					if (myView === subTopicView) {
						let subTopicMap = topicListObjFinal[me.state.selectedTopicIndex].sortedSubTopicArr;
						if(subTopicMap.length > 0){
							me.setState({topics:topicListObjFinal, subtopics:subTopicMap, view:subTopicView});
						}
					}else{
						me.setState({topics:topicListObjFinal, view:myView});
					}				
										
					if(topicListObjFinal && topicListObjFinal[0].subTopicMap && topicListObjFinal[0].subTopicMap){
						var purchased = false;
						try{
						  purchased = Object.values(topicListObjFinal[0].subTopicMap)[0].purchased;
						}catch(e){}
						me.setState({purchased:purchased});
					}
					//console.log("lalala ::" , topicListObjFinal);
					
				}else{
					me.setState({message:me.rb("home.notopics"), view:messageView});
				}
			}else if(response.code === 400) {
				me.setState({message:me.rb("home.notopics"), view:messageView});
			}
			else {
				me.setState({message:me.rb("error.oops"), view:messageView});
			}
			
			
		}

		var callBackFailure = function(response){
			me.setState({message:me.rb("error.oops"), view:messageView});
			me.showAlert(me.rb("503.title"),me.rb("503.msg"));
		}
		
		new HmAjax(this.getUrlFor("GET_PLP_TOPICS")+"?access="+accessId+"&level="+me.selectedGradeOption.value).get(callBackSuccess,callBackFailure);	
		
		
		try{
			this.gradeStore = {
				"grd":me.selectedGradeOption.value,
				"prod":accessId
			}
			this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));
		}catch(e){}
		
		
		try{
			var trackObj = {
				"grade_id": me.selectedGradeOption.value,
				"product_type": accessId,
				"source":this.getTracker().enums.selectedProductSource.home
			}			
	
			this.initiateTrack("product_selected",trackObj);
		}catch(e){}
		
		$(".hometopmenu").removeClass("selected");
		$(".allTopics").addClass("selected");
			
	}
	onTopicChangedEvent(topicMap,selectedTopicIndex,boxColor){	
		var me = this;	
		let subTopicMap = topicMap.sortedSubTopicArr;
		if(subTopicMap.length > 0){
			this.setState({subtopics:subTopicMap, view:subTopicView, selectedTopic:topicMap, selectedTopicIndex:selectedTopicIndex, subTopicBoxColor:boxColor});
		}else{
			me.setState({message:me.rb("home.nosubtopics"), view:messageView});
		}
		
		
		var trackObj = {
			"item_id": topicMap.topicId,
			"item_type": this.getTracker().enums.selectedItemType.topic,
			"source": this.getTracker().enums.selectedItemSource.home
		}

		this.initiateTrack("item_selected",trackObj);
	}
	onSubTopicChangedEvent(subtopicMap,typelbl=""){	
		
		var testId = subtopicMap.testId;
		var classId = subtopicMap.classId;
		var testStatus = subtopicMap.testStatus || subtopicMap.status;
		var recommendtestid = subtopicMap.recommendtestid;
		var reqTestStatus = subtopicMap.reqTestStatus;

		var selectedtopicsubtopicId = subtopicMap.topicsubtopicId;
		var selectedrevisiontestid = subtopicMap.revisiontestid;
		
		this.TestTypeLbl = typelbl;
		
		this.setState({selectedSubTopic:subtopicMap});
		
		//console.log(subtopicMap)
		if(this.state.lessonOnlyMode){
			var lessonList = subtopicMap.lessonsSubTopicArr;			
			this.showLessonOnlyModal(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicMap);
		}else{
			if(testStatus.toUpperCase() == "COMPLETED"){
				if(recommendtestid == 0 || recommendtestid == null){				
					alert("show revision scorecared for testId="+testId);
				}else if(reqTestStatus == "COMPLETED"){	
					alert("show recommendation scorecared for testId="+recommendtestid);
				}else{				
					//alert("start Practice for recommendtestid="+recommendtestid);
					this.showModal(recommendtestid,selectedtopicsubtopicId,selectedrevisiontestid,classId);
					this.fireMobileToast();
				}
			}else{			
				this.showModal(testId,selectedtopicsubtopicId,selectedrevisiontestid,classId);
				this.fireMobileToast();
			}
		}
		
		
		
		
		var trackObj = {
			"item_id": subtopicMap.topicsubtopicId,
			"item_type": this.getTracker().enums.selectedItemType.subtopic,
			"source": this.getTracker().enums.selectedItemSource.home
		}

		this.initiateTrack("item_selected",trackObj);
		
	}

	showAllTopics(){
		this.setState({view:topicView,selectedTopicIndex:null});
	}
	showLessonOnlyModal(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj){	
		
		this.setState({ modalShow: true, modalContent:this.getLessonModalContent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj), modalTitle:subtopicObj.subTopicName, modalView:"lessonInfo" });
		//alert(lessonId+", "+lessonName+", "+lessonUrl+", "+lessonDd);
		//this.setSlick();
	}
	showModal(testId,topicsubtopicId=null,revisiontestid=null,classId){				
		this.setState({ modalShow: true, modalContent:this.setTestInfoScreen(testId,topicsubtopicId,revisiontestid,classId), modalTitle:"", modalView:"testInfo" });
	}	
	setTestInfoScreen(testId,topicsubtopicId,revisiontestid,classId){
	  return <Ms_testinfo callbackParent={this.startTest} accessId={this.accessId} testId={testId} topicsubtopicId={topicsubtopicId} revisiontestid={revisiontestid} classId={this.selectedGradeOption.value} onRef={ref => (this.getTestInfoComponent = ref)} gradeName={this.selectedGradeOption.label}/>
	}
	loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid){		
		return <GetTest topicInfoObj={topicInfoObj} topicsubtopicId={topicsubtopicId} revisiontestid={revisiontestid} onRef={ref => (this.getTestComponent = ref)} gradeName={this.selectedGradeOption.label} subtopic={this.state.selectedSubTopic} closeTimer={this.closeTimer} callbackParent={this.getelapsedTime}  startTimer={this.startTimer} resumeTimer={this.resumeTimer} pauseTimer={this.pauseTimer} closeTimer={this.closeTimer} />
	}

	getelapsedTime(){
		return this.state.elapsedTime;
	}

	updateelapsedTime(time){
		this.setState({elapsedTime:time})
	}
	
	hideSubscribeModal(){
		this.setState({SubscribeModal:false});
	}
	
	showSubscribemodal(){
		this.setState({SubscribeModal:true});
	}
	
	  rendershowSubscribe(dataga,subtopictitle){
		return(
			<div id="ss-modal">							
					<TestTakingModalComponent visible={this.state.SubscribeModal} dialogClassName={"fullwidthdiag grademodal"}>						
					<div className="modal-header bg-purple">
					<div className="modal-title">
					{/* {subtopictitle} */}
					</div>
					<div className="close helpClose" onClick={this.hideSubscribeModal} aria-label="Close">
							  <span aria-hidden="true"><i className="material-icons">close</i></span>
							</div>
					</div>
						<div className="modal-body" className="col-12 text-center subscrcont">
							<SubscribeModal ga={dataga}></SubscribeModal>
						</div>							
					</TestTakingModalComponent>
				</div>
		);
	}

	setSlick(){
		$('.responsive').slick({
		  dots: true,
		  infinite: false,
		  speed: 300,
		  slidesToShow: 4,
		  slidesToScroll: 4,
		  responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		        infinite: true,
		        dots: true
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		    // You can unslick at a given breakpoint now by adding:
		    // settings: "unslick"
		    // instead of a settings object
		  ]
		});
	}

	subscribeFn(props,dataga){
		if(props){
			return super.subscribeFn(dataga);
		}
	}
	
	 getLessonModalContent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj){
		var accessId = 0;
		var accessId = !isNaN(this.selectedProductOption.value) ? this.selectedProductOption.value : accessId;
		var classId = this.selectedGradeOption.value;
		var isFreeTrial = subtopicObj.practiceLocked;
		
		// if(!subtopicObj.practiceLocked){
		// 	var classIdCount = this.getClassIdforAccessCount(classId);
		// 	if(classIdCount>1){
		// 		isFreeTrial = true;
		// 	}
		// }

		//console.log("lessonList::",lessonList);
	
		return(
			<div>	
			<br />
			<div className="col-12">
			<h4>{this.rb("home.lessons")}</h4>
			</div>
			
			<div className="row allMiddle">
			<div className="col-sm-12 col-12 col-md-2 col-lg-2">							
			<img src={recomLessonIcon} />
			</div>
			<div className="col-sm-12 col-12 col-md-10 col-lg-10">
			<div>{this.rb("scorecard.recommended.rawtext2")}</div>
			</div>
			</div>						

			<div className="row allMiddle">
			<div className="col-sm-8 col-8 col-md-10 col-lg-10 imgGal">
			<div className="col-12 text-center scorecardLessons">
			<Slider {...settings}>
			{lessonList.map((lesson,index) =>
				<LessonComponent isFrom={"Home"} isFreeTrail={isFreeTrial} lesson={lesson} testId={testId} topicSubTopicMapId={selectedtopicsubtopicId} accessId={accessId} classId={classId} key={index} tracksource="subtopic" />
				)}
				</Slider>
				</div>
				<div className="col-12 text-center allMiddle">
					{this.subscribeFn(isFreeTrial,"Post login - Class "+classId+" - Lessons - "+this.state.selectedTopic.topicName+" - "+subtopicObj.subTopicName+" - Lessons - Subscribe")}
				</div>
				</div>
				
				</div>
				
				</div>						
				
				);
	}

	onCloseHandler(){
		try{
			if(this.getTestComponent && typeof this.getTestComponent.onCloseHandler === "function"){
				this.getTestComponent.onCloseHandler();
			}else{
				console.warn("Not submitting this test: function 'onCloseHandler' not available");
			}					
		}catch(e){
			console.error(e);
		}
	}

	hideModal(){
		try{			
			if(this.getTestComponent){
				this.closeTimer();
				this.getTestComponent.modalCloseEvent();
			}else if(this.getTestInfoComponent){
				this.getTestInfoComponent.trackTestClose();
			}			
		}catch(e){
		}
		this.onCloseHandler();

		this.getTestComponent = null
		this.getTestInfoComponent = null;


		this.setState({ modalShow: false, modalContent:"loading", view:loadingView, modalTitle:"", modalView:"loading" });
		this.getTopicList(subTopicView);
	}
	
	setModalClass(){
		if(this.state.modalView == "testView"){
			return " modal-lg custom-modal";
		}
		return " modal-lg";
	}
	setModalBackdropClose(){
		if (this.state.modalView == "lessonInfo") {
			return this.hideModal;
		} 
		return "";
	}
	setModalTitle(topicInfoObj){
		/* let testType = "";
		if(topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1"){
			testType = " - "+ this.rb("home.proficiencytest");
		}else{
			//testType = this.rb("home.practicetest");
		} */
		let topics = topicInfoObj.testDetails.topics;//.split("- Customized Practice").join("- Customised Practice");	
		
		return topics; //+ testType;
	}
	loadModalContent(){
		if (this.state.modalContent === "loading") {
			return(
				<div className="text-center loadingAnim">
				<Loader 
				type="Oval"
				color="#00BFFF"
				height="100"	
				width="100"
				/>
				</div>
				)
			}else{
				return(
				<div>
				{this.state.modalContent}						
				</div>
				)
			}

		}
		startTest(topicInfoObj,topicsubtopicId,revisiontestid){
			var me=this;
			let durationInSeconds = false;
			if(topicInfoObj && topicInfoObj.testDetails){
				durationInSeconds =  topicInfoObj.testDetails.durationInSeconds > 0 ? true : false;
			}
			this.setState({  modalContent:this.loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid), modalTitle:this.setModalTitle(topicInfoObj), modalView:"testView",timerShow:durationInSeconds });
			if(topicInfoObj && topicInfoObj.testDetails){
				try{
					me.starttime = topicInfoObj.testDetails.durationInSeconds;
					me.topicInfoObj = topicInfoObj;
					me.setState({elapsedTime:me.topicInfoObj.userTest.elapsedTime})
				}catch(e){
					console.log("timer not saved");
				}
			}

			let source_test_id = 0;
			let resumed = null;
			if(topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1"){
				source_test_id = null;
				
				if(this.state.selectedSubTopic.status == "NEW"){
					resumed = false;
				}
				else if(this.state.selectedSubTopic.status == "IN_PROGRESS"){
					resumed = true;
				}
				
			}else{
				source_test_id = this.state.selectedSubTopic.testId;
				
				if(this.state.selectedSubTopic.reqTestStatus == "NEW"){
					resumed = false;
				}
				else if(this.state.selectedSubTopic.reqTestStatus == "IN_PROGRESS"){
					resumed = true;
				}
				
			}

			
			
			
			var trackObj = {
				"subtopic_id" : topicsubtopicId,
				"test_id": topicInfoObj.testDetails.id,
				"source_test_id": source_test_id,
				"resumed": resumed
			}
			this.initiateTrack("test_started",trackObj);
		}
		topicPointClick(event){
			var target = event.currentTarget;
			$(".hometopmenu").removeClass("selected");
			$(target).addClass("selected");
			
			if($(target).hasClass("allTopics")){
				this.setState({topicSubView:allTopicsView});
				
			}else if($(target).hasClass("pointssystem")){				
				gradePointsMap.grades = gradePointsMap.grades.reverse();
				//console.log(gradePointsMap.grades);		
				this.setState({topicSubView:pointsSystemView});
			}
			
		}

		custsubscribeFn(dataga){
				return(
					<div className="pointssystem hometopmenu float-right sub-mb-10">
								<span id="SubscribeButton" className="">
					<span className="btn btn-primary largeBtn subscribe_style subhome" data-ga={ dataga || "Post login - Subscribe"} onClick={()=>{
						window.location.href="/myproducts";
					}}>Subscribe</span>      
				</span></div>
				)
		}
		closeTimer(){
			//console.log("closeTimer", this.refs.TimerComp);
			if(ReactDOM.findDOMNode(this.refs.TimerComp)){
				if(typeof this.refs.TimerComp.stopTimer === "function"){
					this.refs.TimerComp.stopTimer();
				}				
			}

			/*if(this.timerComp && typeof this.timerComp.stopTimer === "function"){
				this.timerComp.stopTimer();
			}*/

			this.setState({timerShow:false});
		}

		pauseTimer(){
			if(ReactDOM.findDOMNode(this.refs.TimerComp)){
				if(typeof this.refs.TimerComp.pauseTimer === "function"){
					this.refs.TimerComp.pauseTimer();
				}				
			}

		/*	if(this.timerComp && typeof this.timerComp.pauseTimer === "function"){
				this.timerComp.pauseTimer();
			}*/

			this.setState({timerShow:true});
		}

		resumeTimer(){
			if(ReactDOM.findDOMNode(this.refs.TimerComp)){
				if(typeof this.refs.TimerComp.resumeTimer === "function"){
					this.refs.TimerComp.resumeTimer();
				}				
			}

			/*if(this.timerComp && typeof this.timerComp.resumeTimer === "function"){
				this.timerComp.resumeTimer();
			}*/

			this.setState({timerShow:true});
		}

		startTimer(){
			if(ReactDOM.findDOMNode(this.refs.TimerComp)){
				if(typeof this.refs.TimerComp.startTimer === "function"){
					this.refs.TimerComp.startTimer();
				}				
			}

			/*if(this.timerComp && typeof this.timerComp.startTimer === "function"){
				this.timerComp.startTimer();
			}*/

			this.setState({timerShow:true});
		}

		autoSubmit(){
			if(this.getTestComponent && typeof this.getTestComponent.submitClick === "function"){
				this.getTestComponent.submitClick(true);
			}
		}
		
		renderTopics(){
			var me = this;
			

			if(this.state.view === topicView && this.state.lessonOnlyMode && !this.isLessonTabAvailable()){
				this.setState({view:desktopOnlyView});
			}

			//console.log("view:::",this.state.view);

			if(this.state.view === desktopOnlyView){
				return(
					<DesktopOnly/>
				)
			} else if (this.state.view === loadingView) {
				return (
				<div className="text-center loadingAnim">
				<Loader 
				type="Oval"
				color="#00BFFF"
				height="100"	
				width="100"
				/>
				</div>
				)
			}else if(this.state.view === messageView){
				return (
				<div className="messageView text-center">
				<h3>{this.state.message}</h3>
				</div>
				)
			}
			else if (this.state.view === topicView) {
				let topics = this.state.topics; 
				let topicLength = topics.length;
				var classId = this.selectedGradeOption.value;

				return (
					<div>
						{/* <div className="topicspointsheader"> */}
						
							{/* {(() => {
								if(!me.state.purchased){
								  return this.custsubscribeFn(me.state.lessonOnlyMode ? "Post login - Class "+classId+" - Lessons - Subscribe":"Post login - Class "+classId+" - Tests - Subscribe");
								}
							})()} */}

							{/* <div className="allTopics hometopmenu selected" onClick={this.topicPointClick}>
								{this.rb("landing.alltopics")} 
								<span className="badge badge-corner">{topicLength}</span>
							</div>
							
							
							{(() => {
								if(this.state.lessonOnlyMode == false){
									return(
										<div className="pointssystem hometopmenu"  onClick={this.topicPointClick}>
											{this.rb("points.pointssystem")} 
										</div>
									);
								}
							})()}

							
								
							
						</div> */}
						

						{(() => {console.log("this.state.topicSubView=="+this.state.topicSubView);
		    		       if(this.state.topicSubView == pointsSystemView){	
		    		    	   return(
		    		    			  <div id="pointsContainer" className="homeTopicContainer mainScrollContent">
		    		    			  	<div>
											<div className="pointsheadertxt">{this.rb("points.ptest")}</div>
											<div>{this.rb("points.testmsg")}</div>
											<div className="pointsTable testtable">
												<Table className="table noleftpadding">													
													<Tbody>
														<Tr>
															<Td className="dark">{this.rb("points.hardquestions")}</Td>
															<Td className="medium">{gradePointsMap.points.hard[1]}</Td>
														</Tr>
														<Tr>
															<Td className="dark">{this.rb("points.mediumquestions")}</Td>
															<Td className="medium">{gradePointsMap.points.medium[1]}</Td>
														</Tr>
														<Tr>
															<Td className="dark">{this.rb("points.easyquestions")}</Td>
															<Td className="medium">{gradePointsMap.points.easy[1]}</Td>
														</Tr>
													</Tbody>
												</Table>
											</div>
										</div>
										<div>
											<div className="pointsheadertxt">{this.rb("points.cpractice")}</div>											
											<div className="pointsTable practicetable">
												<Table className="table">	
													<Thead>
														<Tr>
															<Td className="dark">{this.rb("points.answeredrightly")}</Td>
															<Td className="dark">{this.rb("points.hardquestion")}</Td>
															<Td className="dark">{this.rb("points.mediumquestion")}</Td>
															<Td className="dark">{this.rb("points.easyquestion")}</Td>
														</Tr>
													</Thead>
													<Tbody>
														<Tr>
															<Td className="dark">{this.rb("points.1attempt")}</Td>
															<Td className="medium">{gradePointsMap.points.hard[1]}</Td>
															<Td className="medium">{gradePointsMap.points.medium[1]}</Td>
															<Td className="medium">{gradePointsMap.points.easy[1]}</Td>
														</Tr>
														<Tr>
															<Td className="dark">{this.rb("points.2attempt")}</Td>
															<Td className="medium">{gradePointsMap.points.hard[2]}</Td>
															<Td className="medium">{gradePointsMap.points.medium[2]}</Td>
															<Td className="medium">{gradePointsMap.points.easy[2]}</Td>
														</Tr>
														<Tr>
															<Td className="dark">{this.rb("points.3attempt")}</Td>
															<Td className="medium">{gradePointsMap.points.hard[3]}</Td>
															<Td className="medium">{gradePointsMap.points.medium[3]}</Td>
															<Td className="medium">{gradePointsMap.points.easy[3]}</Td>
														</Tr>
													</Tbody>
												</Table>
											</div>
										</div>
										
										<div>
											 <div className="pointsheader2txt">{this.rb("points.gradingsystem")}</div>	
											 <div className="pointsheadertxt">{this.rb("points.forasubtopic")}</div>
											 <div>Percentage = (Points scored/ Total no.of points in that sub-topic)*100</div>
											 <div className="pointsheadertxt mt-10">{this.rb("points.foratopic")}</div>
											 <div>Percentage = (Total points scored in all subtopics (in that topic)/ Total no.of points of all sub-topics (in that topic))*100</div>
											 <div className="pointsTable gradetable">
												<Table className="table">													
													<Thead>
														<Tr>
															<Th className="dark">{this.rb("points.percentagerange")}</Th>
															<Th className="dark">{this.rb("points.grade")}</Th>
														</Tr>
													</Thead>
													<Tbody>
														{gradePointsMap.grades.map((grades, index) => (
															<Tr>
																<Td className={"green "+grades.grade.toLowerCase().split("+").join("plus")}>{grades.minPercent}% - {grades.maxPercent}%</Td>
																<Td className={"green "+grades.grade.toLowerCase().split("+").join("plus")}>{grades.grade}</Td>
															</Tr>
													    ))}															
													</Tbody>
												</Table>
											</div>
										 </div>
									 
									 </div>
									 
		    		    	   );
		    		       }else{
		    		    	   let selectedGradeLabel = "";
		    		    	   try{
		    		    		   selectedGradeLabel = this.selectedGradeOption.label.split(" ").join("").toLowerCase();
		    		    	   }catch(e){}
		    		    	   
		    		    	   return(		    		    			  
		    		    			  <div id="topicContainer" className="homeTopicContainer mainScrollContent">
										{topics.map((topic,index) =>
											<TopicComponent topic={topic} callbackParent={this.onTopicChangedEvent} key={index} dataIndex={index} lessonOnlyMode={this.state.lessonOnlyMode} selectedGradeLabel={selectedGradeLabel} gradeName={this.selectedGradeOption.label}/>
										)}
									 </div>
		    		    	   );
		    		       }
		    		    })()}
						
						
						
					</div>
				)

			}else if (this.state.view === subTopicView) {
				let subtopics = this.state.subtopics; 			
				let subLength = subtopics.length;
				var accessId = 0;
				var accessId = !isNaN(this.selectedProductOption.value) ? this.selectedProductOption.value : accessId;
				var classId = this.selectedGradeOption.value;
		
				return (
				<div>    
					<div className="float-right">
				{(() => {
								if(!me.state.purchased){
								  return this.custsubscribeFn(this.state.lessonOnlyMode ? "Post login - Class "+classId+" - Lessons - "+this.state.selectedTopic.topicName+" - Subscribe":"Post login - Class "+classId+" - Tests - "+this.state.selectedTopic.topicName+" - Subscribe");
								}
							})()}
				</div>

				<div className="breadcrumb-holder">
				<ul className="breadcrumb">							
				<li className="breadcrumb-item"><a href="javascript:void(0);" onClick={this.showAllTopics}>{this.rb("landing.alltopics_small")}</a></li>
				<li className="breadcrumb-item active">{this.state.selectedTopic.topicName}</li>
				</ul>
				
				

				</div>
				{/* <div><div className="subTopicName">{this.state.selectedTopic.topicName} <span className="badge badge-corner">{subLength}</span></div></div> */}
				<div id="topicContainer" className="homeTopicContainer mainScrollContent">
				{subtopics.map((subtopic,index) =>

					
					<SubTopicComponent key={index} subtopic={subtopic} accessId={accessId} classId={classId} showSubscribe={this.showSubscribemodal} callbackParent={this.onSubTopicChangedEvent} lessonOnlyMode={this.state.lessonOnlyMode} subTopicBoxColor={this.state.subTopicBoxColor} gradeName={this.selectedGradeOption.label} topicName={this.state.selectedTopic.topicName}/>
					)}
					</div>

					<div>							
					<TestTakingModalComponent visible={this.state.modalShow} dialogClassName={this.setModalClass()} onClickBackdrop={this.setModalBackdropClose()}>
					<div className="modal-header bg-purple">
					<div className="modal-title">
					{this.state.modalTitle}
					</div>
					{(() => {
						if(this.state.timerShow){
							return (
								<TimerComp onShow={true} ref='TimerComp' autoSubmit={this.autoSubmit} starttime={this.starttime - this.topicInfoObj.userTest.elapsedTime} testDetails={this.topicInfoObj.testDetails} elapsedTime={this.topicInfoObj.userTest.elapsedTime} callbackParent={this.updateelapsedTime}></TimerComp>
								)
						}
					})()}
					<div className="close" onClick={this.hideModal} aria-label="Close" data-ga={"Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - "+this.state.selectedSubTopic.subTopicName+" - "+this.getTestTypeLbl()}>
					<span aria-hidden="true"><i className="material-icons">close</i></span>
					</div>
					</div>
					<div className="modal-body testModalBody">
					{this.loadModalContent()}
					</div>							
					</TestTakingModalComponent>
					
					
					</div>
					{this.rendershowSubscribe("Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - Subscribe")}
					</div>
					)

				}else if(this.state.productExpired == true){
					return (
						<div className="messageView expiredView text-center">
							<span className="expiredlock"><i class="material-icons">lock</i></span>
							<h3>{this.rb("access.expiredmsg1")}</h3>
							<h3>Go to <span className="r-btn myheymathbtn goprod-btn" onClick={this.goToLanding}>Products</span><span>to subscribe</span></h3>
							{/* <h3>{this.rb("access.expiredmsg2")}</h3> */}
							<h3>{ReactHtmlParser(this.rb("access.expiredmsg3"))}</h3>
						</div>
						)
				}
				else{
					return (
							<div><h1>Nothing</h1></div>
					)
				}
			}

			showProductpage(){
				window.location.href = '/products';
			}

			goToLanding(){
				window.location.href = '/mysubscriptions';
			}

			getTestTypeLbl(){
				if(this.TestTypeLbl == ""){
					return "Close";
				}else{
					return this.TestTypeLbl+" - Close";
				}				
			}
			getProductIndication(){
				if(this.state.modalView == "lessonInfo"){
					return "Lessons";
				}else{
					return "Tests";
				}
			}
				
				render() {					
					if(this.comboNamesLoaded){						
						return super.render(
							<div className="HomeComponent mt-40">							
							{this.renderTopics()}
							</div>
							);	
					}else if(this.state.noProducts){
						return super.render(
							<div className="messageView expiredView text-center">
								<span className="expiredlock"><i class="material-icons">lock</i></span>
								<h3>{this.rb("register.noproducts.msg")}</h3>
								<h3>{this.rb("register.noproducts.msg2")}</h3>
								<h3>{ReactHtmlParser(this.rb("register.noproducts.msg3"))}</h3>
							</div>
							);	
						
					}
					else{
						return super.render(		
							);	
					}
				}
			}

			export default ms_Home;



// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/ms_Home.js